"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _templateObject;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Carousel = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var rgba_1 = __importDefault(require("polished/lib/color/rgba"));

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var react_2 = require("@emotion/react");

var CarouselContent_1 = require("./CarouselContent");

var Carousel = function Carousel(_ref) {
  var children = _ref.children,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title,
      _ref$initialSlide = _ref.initialSlide,
      initialSlide = _ref$initialSlide === void 0 ? 1 : _ref$initialSlide,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? true : _ref$header,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      language = _ref.language;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _ref3 = (0, react_1.useState)(initialSlide),
      _ref4 = _slicedToArray(_ref3, 2),
      currentIndex = _ref4[0],
      setCurrentIndex = _ref4[1];

  var updateIndex = function updateIndex(newIndex) {
    if (newIndex > children.length) {
      setCurrentIndex(1);
    } else if (newIndex < 1) {
      setCurrentIndex(children.length);
    } else {
      setCurrentIndex(newIndex);
    }
  };

  var back = function back() {
    return updateIndex(currentIndex - 1);
  };

  var next = function next() {
    return updateIndex(currentIndex + 1);
  };

  var HeaderContent = (0, react_2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\tborder-bottom: 1px solid ", ";\n\t"])), (0, rgba_1.default)(theme.colors.primary.darkGray, 0.1));
  return (0, jsx_runtime_1.jsxs)("div", {
    className: className,
    "data-testid": dataTestId,
    children: [header && (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      css: HeaderContent,
      alignItems: "center",
      children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        grow: 1,
        children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          variant: "h2",
          children: title
        })
      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        children: (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
          size: "sm",
          color: theme.colors.primary.lightGray,
          children: [currentIndex, " ", CarouselContent_1.CarouselContent[language].ofText, " ", children.length]
        })
      })]
    }), react_1.default.cloneElement(children[currentIndex - 1], {
      back: back,
      next: next
    })]
  });
};

exports.Carousel = Carousel;